import { render, staticRenderFns } from "./wait2pay.vue?vue&type=template&id=a42d3928&scoped=true&"
import script from "./wait2pay.vue?vue&type=script&lang=js&"
export * from "./wait2pay.vue?vue&type=script&lang=js&"
import style0 from "./wait2pay.vue?vue&type=style&index=0&id=a42d3928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42d3928",
  null
  
)

export default component.exports